export default {
  SetMemeModal(state, params) {
    return (state.openMemeModal = params);
  },
  SetActiveLink(state, params) {
    return (state.activeLink = params);
  },
  SetSearchMessage(state, params) {
    return (state.searchMessage = params);
  },
  SetTheme(state, params) {
    return (state.theme = params);
  },
  SelectMeme(state, params) {
    return (state.selectedMeme = params);
  },
  SetProvider(state, params) {
    return (state.provider = params);
  },
  SetWeb3(state, params) {
    return (state.web3 = params);
  },
  SetAccount(state, params) {
    return (state.account = params);
  },
  SetMemePreviews(state, params) {
    return (state.memePreviews = params);
  },
  SetMemeChildren(state, params){
    return (state.memeChildren = params);
  },
  SetFeaturedMemes(state, params) {
    console.log(state)
    return (state.featuredMemes = params);
  },
  SetWalletNFTs(state, params) {
    return (state.nfts = params);
  },
};
